module.exports = __webpack_public_path__ + "static/img/noData.9bb2d2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/display-img/noData.png
// module id = C57F
// module chunks = 15